import React, { useState } from "react";

const positions = [
  "Backend Developer",
  "Backend Engineer",
  "Cloud Engineer",
  "Founding Engineer",
  "Frontend Developer",
  "Frontend Engineer",
  "Full Stack Developer",
  "Full Stack Engineer",
  "Fullstack Python Developer",
  "Javascript Developer",
  "Node.JS Engineer",
  "Node.JS Developer",
  "Python Developer",
  "Senior Software Engineer",
  "Software Engineer",
  "Systems Engineer",
];

const PositionInput = ({ position, setPosition }) => {
  const [showCustom, setShowCustom] = useState(false);
  const [customPosition, setCustomPosition] = useState("");

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === "Others") {
      setShowCustom(true);
      setCustomPosition("");
      setPosition("");
    } else {
      setShowCustom(false);
      setPosition(value);
      setCustomPosition("");
    }
  };

  const handleCustomChange = (e) => {
    setCustomPosition(e.target.value);
    setPosition(e.target.value);
  };

  const isCustomPosition = !positions.includes(position) && position !== "";

  return (
    <div>
      <label>
        Position:
        <select
          value={isCustomPosition || showCustom ? "Others" : position}
          onChange={handleSelectChange}
          style={{ marginLeft: "10px", padding: "5px" }}
        >
          {positions.map((pos) => (
            <option key={pos} value={pos}>
              {pos}
            </option>
          ))}
          <option value="Others">Others</option>
        </select>
      </label>
      {showCustom && (
        <input
          type="text"
          placeholder="Enter custom position"
          value={customPosition}
          onChange={handleCustomChange}
          style={{ marginLeft: "10px", padding: "5px" }}
        />
      )}
    </div>
  );
};

export default PositionInput;
